// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inventar-page {
  padding-bottom: 4rem;
}

.inventar-intro {
  font-family: 'Circular', sans-serif;
  color: #555;
  font-size: 1rem;
  margin: 0.5rem 1rem 1.5rem;
  line-height: 1.5;
}

.inventar-laden,
.inventar-leer {
  font-family: 'Circular', sans-serif;
  color: #aaa;
  text-align: center;
  padding: 2rem;
  font-size: 1rem;
}

/* Geräteliste */
.geraete-liste {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding: 0 1rem;
}

.geraet-card {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  background: white;
  border-radius: 12px;
  padding: 0.9rem 1.1rem;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);
}

.geraet-anzahl {
  font-family: 'Staatliches', sans-serif;
  font-size: 1.5rem;
  color: var(--mittelblau);
  min-width: 2.5rem;
  line-height: 1.2;
  flex-shrink: 0;
}

.geraet-info {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.geraet-name {
  font-family: 'Staatliches', sans-serif;
  font-size: 1.35rem;
  text-transform: uppercase;
  color: #1a1a1a;
}

.geraet-beschreibung {
  font-family: 'Circular', sans-serif;
  font-size: 0.88rem;
  color: #666;
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/components/logistik/Inventar.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;EACnC,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".inventar-page {\n  padding-bottom: 4rem;\n}\n\n.inventar-intro {\n  font-family: 'Circular', sans-serif;\n  color: #555;\n  font-size: 1rem;\n  margin: 0.5rem 1rem 1.5rem;\n  line-height: 1.5;\n}\n\n.inventar-laden,\n.inventar-leer {\n  font-family: 'Circular', sans-serif;\n  color: #aaa;\n  text-align: center;\n  padding: 2rem;\n  font-size: 1rem;\n}\n\n/* Geräteliste */\n.geraete-liste {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  padding: 0 1rem;\n}\n\n.geraet-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  background: white;\n  border-radius: 12px;\n  padding: 0.9rem 1.1rem;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);\n}\n\n.geraet-anzahl {\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.5rem;\n  color: var(--mittelblau);\n  min-width: 2.5rem;\n  line-height: 1.2;\n  flex-shrink: 0;\n}\n\n.geraet-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.geraet-name {\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.35rem;\n  text-transform: uppercase;\n  color: #1a1a1a;\n}\n\n.geraet-beschreibung {\n  font-family: 'Circular', sans-serif;\n  font-size: 0.88rem;\n  color: #666;\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
